import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../utility/Button';
import { Formik, Field } from 'formik';
import ErrorDisplay from '../utility/ErrorDisplay';
import LottieLoader from '../utility/LottieLoader';
import CustomTextArea from '../utility/CustomTextArea';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { validateMinLength } from '../../js/validators';
import CoverPhoto from '../utility/CoverPhoto';
import Message from '../utility/Message';
import iconLocation from '../../images/icons/icon_32_location.png';
import RatingWidget from './RatingWidget';
import { Helmet } from 'react-helmet';
import Cookies from 'js-cookie';

import iconBYOC from '../../images/icons/icon_fordvehicle_yellow.png';

import {
  fetchCreateReview,
  postReviewForm,
  fetchCreateReviewPublic,
  postReviewFormPublic
} from '../../actions/reviews';

import { clearApiError } from '../../actions/api';

import { SITE_TITLE } from '../../constants';

import { parseQueryString } from '../../js/utility';

class Review extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initData: false
    };
    this.initialValues = {
      rating: 5,
      reviewText: '',
      vehicleReviewText: ''
    };
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    const { clearApiError } = this.props;
    clearApiError();
    this.initData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async initData() {
    const { fetchCreateReview, fetchCreateReviewPublic } = this.props;

    if (this.props.public) {
      const qs = parseQueryString();
      await fetchCreateReviewPublic(this.props.match.params.uuid, qs.token);
    } else {
      await fetchCreateReview(this.props.match.params.uuid);
    }

    const { error } = this.props;
    if (!error && this._isMounted) {
      this.setState({
        initData: true
      });
    }
  }

  submitForm(values) {
    const {
      postReviewForm,
      postReviewFormPublic,
      reviewInfo,
      match
    } = this.props;
    const uuid = match.params.uuid;
    const formData = {
      booking_uuid: uuid,
      participant_id: reviewInfo.participant_id,
      review: values.reviewText,
      rating: values.rating,
      vehicle_review: values.vehicleReviewText,
      vehicle_id: reviewInfo.vehicle.id
    };

    if (this.props.public) {
      formData.token = parseQueryString().token;
    }

    const data = JSON.stringify(formData);
    const xsrf = decodeURIComponent(Cookies.get('XSRF-TOKEN'));

    if (this.props.public) {
      postReviewFormPublic(data, xsrf);
    } else {
      postReviewForm(data, xsrf);
    }
  }

  render() {
    const { initData } = this.state;
    const { error, loading, t } = this.props;
    if (error) {
      return <ErrorDisplay error={error} />;
    }
    if (!initData || loading) {
      return (
        <>
          <LottieLoader />
        </>
      );
    }
    const { reviewInfo, message } = this.props;
    return (
      <>
        <Helmet>
          <title>
            {t('trip:leaveAReview')} | {SITE_TITLE}
          </title>
        </Helmet>
        {message !== '' ? (
          <Message title={t('trip:thankYouForReview')} text={message} />
        ) : (
          <div className='fe-review'>
            <div className='container'>
              <div className='row'>
                <div className='col-lg-8'>
                  <h1 className='fe-heading'>{t('trip:leaveAReview')}</h1>
                  <CoverPhoto
                    mobileUrl={reviewInfo.photo_cover.mobile_view}
                    desktopUrl={reviewInfo.photo_cover.desktop_view}
                  />
                  <div className='fe-review-form'>
                    <h2 className='fe-review-form-title'>{reviewInfo.title}</h2>
                    <div className='fe-review-location'>
                      <img src={iconLocation} alt='' />
                      <span>{reviewInfo.location}</span>
                    </div>
                    <Formik
                      validateOnChange={true}
                      validateOnBlur={true}
                      initialValues={this.initialValues}
                      onSubmit={values => {
                        this.submitForm(values);
                      }}
                    >
                      {({ errors, handleSubmit, setFieldValue, values }) => (
                        <form
                          noValidate
                          onSubmit={handleSubmit}
                          className='fe-form'
                        >
                          <div className='fe-form-content'>
                            <div className='fe-form-field full'>
                              <label>{t('trip:rateYourExperience')}</label>
                              <RatingWidget
                                customFieldValue='rating'
                                customOnChange={setFieldValue}
                              />
                            </div>
                          </div>
                          <div className='fe-form-content'>
                            <div className='fe-form-field full'>
                              <label htmlFor='reviewText'>
                                {t('trip:describeYourExperience')}
                              </label>
                              <Field
                                type='text'
                                name='reviewText'
                                minLength={10}
                                maxLength={null}
                                validate={() =>
                                  validateMinLength(values['reviewText'], 10)
                                }
                                component={CustomTextArea}
                              />
                            </div>
                          </div>
                          {/* <div className="fe-form-content">
                            <div className="fe-form-field full">
                              <label className="fe-form-label">{t('trip:yourVehicle')}</label>
                              <div className="fe-my-booking-item-vehicle review">
                                {!reviewInfo.is_own_vehicle ?
                                  <div className="fe-my-booking-item-vehicle-thumb">
                                    <div className="fe-u-thumb-3by1">
                                      <img src={reviewInfo.vehicle.img_url} alt=""/>
                                    </div>
                                  </div> :
                                  <img className="fe-my-booking-item-byoc" src={iconBYOC} alt=""/>}
                                <span>{!reviewInfo.is_own_vehicle ? reviewInfo.vehicle.model : t('gen:bringOwnRanger')}</span>
                              </div>
                            </div>
                          </div> */}

                          {/* Hide driving exp */}
                          {/* <div className='fe-form-content'>
                            <div className='fe-form-field full'>
                              <label htmlFor='reviewText'>
                                {t('trip:shareDrivingExperience')}
                              </label>
                              <Field
                                type='text'
                                name='vehicleReviewText'
                                minLength={10}
                                maxLength={null}
                                validate={() =>
                                  validateMinLength(
                                    values['vehicleReviewText'],
                                    10
                                  )
                                }
                                component={CustomTextArea}
                              />
                            </div>
                          </div> */}
                          <div className='fe-form-buttons no-margin'>
                            <Button type='submit'>{t('form:submit')}</Button>
                          </div>
                          <span className='fe-form-error'>
                            {Object.entries(errors).length > 0
                              ? t('error:incompleteForm')
                              : ''}
                          </span>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

Review.propTypes = {
  error: PropTypes.object,
  t: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  clearApiError: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  fetchCreateReview: PropTypes.func.isRequired,
  postReviewForm: PropTypes.func.isRequired,
  fetchCreateReviewPublic: PropTypes.func.isRequired,
  postReviewFormPublic: PropTypes.func.isRequired,
  reviewInfo: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  public: PropTypes.bool
};

const mapStateToProps = ({ apiState, reviewsState }) => ({
  error: apiState.error,
  loading: reviewsState.loading,
  reviewInfo: reviewsState.reviewInfo,
  message: reviewsState.message
});

const mapDispatchToProps = {
  fetchCreateReview,
  postReviewForm,
  fetchCreateReviewPublic,
  postReviewFormPublic,
  clearApiError
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Review)
);
